import React from 'react';
import PropTypes from 'prop-types';
import { UnreadCounter } from '@ers/ui';
import { Typo } from '@ers/ui/';

const MessagesMenuItem = ({ name }) => (
    <>
        <Typo.Menu>{name}</Typo.Menu>
        <UnreadCounter />
    </>
);

MessagesMenuItem.propTypes = {
    name: PropTypes.string.isRequired,
};

export default MessagesMenuItem;